import { firestoreDateParser } from '@pedix-workspace/utils';
import { InventoryEntry } from './stock.types';
import { withNestedConverter } from '@pedix-workspace/shared-models';

export const getInventoryEntryConverter = withNestedConverter<InventoryEntry>({
  fromFirestore(snapshot) {
    const entry = <InventoryEntry>snapshot.data();

    return <InventoryEntry>{
      ...entry,
      id: snapshot.id,
      created: firestoreDateParser(entry.created),
      details: {
        ...entry.details,
        lines: entry.details?.lines || [],
      },
    };
  },
  toFirestore(entry: InventoryEntry): InventoryEntry {
    return entry;
  },
});
